import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/quote-review", label: "Quote Review" },
  { to: "/park-home-urgent-repairs", label: "Urgent Support" },
  { to: "/insurance", label: "Insurance Guidance" },
  { to: "/inspections", label: "Inspections" },
  { to: "/support-plan", label: "Support Plan" },
  { to: "/operators", label: "Operators" },
  { to: "/pay", label: "Pay Invoice" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#F7F4ED]/90 backdrop-blur-xl border-b border-[#D7E7DF]/70"
    >
      <div className="container-phs flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <img
            src="/images/logo-light.png"
            alt="Park Home Support"
            className="h-14 w-auto sm:hidden"
            width={120}
            height={56}
          />
          <img
            src="/images/logo-light.png"
            alt="Park Home Support"
            className="hidden sm:block h-16 w-auto"
            width={220}
            height={64}
          />
        </Link>

        <nav className="hidden xl:flex items-center gap-6" data-testid="primary-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-[0.9rem] font-medium transition-colors ${
                  isActive ? "text-[#064E2E]" : "text-[#071A33] hover:text-[#0F766E]"
                }`
              }
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:block">
          <Link to="/membership" className="btn-primary text-sm" data-testid="header-join-now-btn">
            Join Now
          </Link>
        </div>

        <button
          className="xl:hidden p-2 text-[#071A33]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-[#D7E7DF] bg-[#F7F4ED]" data-testid="mobile-nav">
          <div className="container-phs py-5 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-[#064E2E]" : "text-[#071A33]"}`
                }
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/membership"
              onClick={() => setOpen(false)}
              className="btn-primary mt-3 text-sm"
              data-testid="mobile-join-now-btn"
            >
              Join Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
